import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentObject } from '../models/delivery';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class DeliveryService {
    constructor(private readonly apiService: ApiService) {}

    getProviderList(data: ShipmentObject) {
        return this.apiService.post('/api/shipping/available-providers', data);
    }

    getDeliveryCosts(data: ShipmentObject): Observable<{ cost: string; currency?: string; eta: string }[]> {
        return this.apiService.post<{ cost: string; currency?: string; eta: string }[]>('/api/shipping/cost', data);
    }
}
